module.exports = {
    apiKey: 'AIzaSyCa3MVxUnKJUFZjgNswqm-MyEUxTBh4oUc',
    authDomain: 'i-work-out-56987.firebaseapp.com',
    projectId: 'i-work-out-56987',
    storageBucket: 'i-work-out-56987.appspot.com',
    messagingSenderId: '924555046683',
    appId: '1:924555046683:web:860f3f7570118ad43fadbe',
    measurementId: 'G-MV4ECY6EQZ'
}
